import React, { createContext, useContext, useEffect, useState } from "react";

const AppContext = createContext(null);

function getDeviceId() {
  let id = localStorage.getItem("bv_device_id");
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("bv_device_id", id);
  }
  return id;
}

export function AppProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("bv_lang") || "en");
  const [deviceId] = useState(getDeviceId);

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("bv_lang", l);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <AppContext.Provider value={{ lang, setLang, deviceId }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
}
